// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._63e022{display:flex;border-bottom:1px solid var(--subtle);gap:1.5em;align-items:center}._63e022>.e7fb61{border-radius:0;box-shadow:none;padding:.5em 0}._63e022>.e7fb61:hover{background:linear-gradient(transparent calc(100% - 1px), currentColor calc(100% - 1px)) !important}._63e022>[aria-pressed=true]{pointer-events:none;background:linear-gradient(transparent calc(100% - 2px), currentColor calc(100% - 2px)) !important;font-weight:bold}.dd58e5>.e7fb61{padding-top:0}", ""]);
// Exports
exports.locals = {
	"tabs": "_63e022",
	"tab": "e7fb61",
	"first": "dd58e5"
};
module.exports = exports;
